/**
 * SourceListItem - ein nummerierter Quelleneintrag (Ziel der [n]-Verweise).
 * Verknuepfte Quellen zeigen Titel als Link plus Notiz, reine Textquellen
 * zeigen den Text und die darin enthaltene URL als Link.
 */
import type { ReactNode } from "react";
import type { NumberedSource } from "@/hooks/useSourceCitations";

const LINK_STYLE = {
  color: "var(--accent-cyan, #67e8f9)",
  textDecoration: "underline",
  wordBreak: "break-word" as const,
};

export function SourceListItem({
  entry,
  domId,
  highlighted,
  cite,
}: {
  entry: NumberedSource;
  domId: string;
  highlighted: boolean;
  cite: (text: string | null | undefined) => ReactNode;
}) {
  return (
    <li
      id={domId}
      tabIndex={-1}
      style={{
        borderRadius: 6,
        padding: "2px 6px",
        marginLeft: -6,
        background: highlighted ? "rgba(103,232,249,0.16)" : "transparent",
        transition: "background 0.3s",
      }}
    >
      <span style={{ color: "var(--text-muted)" }}>[{entry.n}] </span>
      {entry.kind === "linked" ? (
        <>
          <a href={entry.s.url} target="_blank" rel="noopener noreferrer" style={LINK_STYLE}>
            {entry.s.title}
          </a>
          {entry.s.publisher ? (
            <span style={{ color: "var(--text-muted)" }}> - {entry.s.publisher}</span>
          ) : null}
          {entry.note ? (
            <span
              style={{
                display: "block",
                color: "var(--text-muted)",
                fontSize: "0.8rem",
                lineHeight: 1.5,
              }}
            >
              {cite(entry.note)}
            </span>
          ) : null}
        </>
      ) : (
        <>
          {entry.text}
          {entry.url ? (
            <>
              {entry.text ? " " : null}
              <a href={entry.url} target="_blank" rel="noopener noreferrer" style={LINK_STYLE}>
                {entry.url.replace(/^https?:\/\/(www\.)?/, "")}
              </a>
            </>
          ) : null}
        </>
      )}
    </li>
  );
}

